import { useMutation, useQuery, useQueryClient } from "react-query";
import * as api from "../api/GeneralApi";

//////////////////////////////////////////////////
//-------------------- NAME --------------------//
//////////////////////////////////////////////////

//--- get names ---//
export const GetNames = () => {
  return useQuery(["names"], api.fetchNames);
};

//--- get name ---//
export const GetName = (nameId) => {
  const queryClient = useQueryClient();
  return useQuery(["name", nameId], api.fetchName, {
    initialData: () => {
      const name = queryClient
        .getQueryData("name")
        ?.data.find((name) => name.id === parseInt(nameId));
      if (name) {
        return {
          data: name,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create name ---//
export const CreateName = () => {
  return useMutation(api.postName);
};

//--- update name ---//
export const UpdateName = () => {
  return useMutation(api.putName);
};

//--- delete name ---//

//////////////////////////////////////////////////
//-------------------- PHONE --------------------//
//////////////////////////////////////////////////

//--- get phones ---//
export const GetPhones = () => {
  return useQuery(["phones"], api.fetchPhones);
};

//--- get phone ---//
export const GetPhone = (phoneId) => {
  const queryClient = useQueryClient();
  return useQuery(["phone", phoneId], api.fetchPhone, {
    initialData: () => {
      const phone = queryClient
        .getQueryData("phone")
        ?.data.find((phone) => phone.id === parseInt(phoneId));
      if (phone) {
        return {
          data: phone,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create phone ---//
export const CreatePhone = () => {
  return useMutation(api.postPhone);
};

//--- update phone ---//
export const UpdatePhone = () => {
  return useMutation(api.putPhone);
};

//--- delete phone ---//

//////////////////////////////////////////////////
//-------------------- EMAIL --------------------//
//////////////////////////////////////////////////

//--- get emails ---//
export const GetEmails = () => {
  return useQuery(["emails"], api.fetchEmails);
};

//--- get email ---//
export const GetEmail = (emailId) => {
  const queryClient = useQueryClient();
  return useQuery(["email", emailId], api.fetchEmail, {
    initialData: () => {
      const email = queryClient
        .getQueryData("email")
        ?.data.find((email) => email.id === parseInt(emailId));
      if (email) {
        return {
          data: email,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create email ---//
export const CreateEmail = () => {
  return useMutation(api.postEmail);
};

//--- update email ---//
export const UpdateEmail = () => {
  return useMutation(api.putEmail);
};

//--- delete email ---//

////////////////////////////////////////////////////
//-------------------- COUNTY --------------------//
////////////////////////////////////////////////////

//--- get counties ---//
export const GetCounties = () => {
  return useQuery(["counties"], api.fetchCounties);
};

//--- get county ---//
export const GetCounty = (countyId) => {
  const queryClient = useQueryClient();
  return useQuery(["county", countyId], api.fetchCounty, {
    initialData: () => {
      const county = queryClient
        .getQueryData("county")
        ?.data.find((county) => county.id === parseInt(countyId));
      if (county) {
        return {
          data: county,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create county ---//
export const CreateCounty = () => {
  return useMutation(api.postCounty);
};

//--- update county ---//
export const UpdateCounty = () => {
  return useMutation(api.putCounty);
};

//--- delete county ---//

////////////////////////////////////////////////////////
//-------------------- REALESTATE --------------------//
////////////////////////////////////////////////////////

//--- get realestates ---//
export const GetRealEstates = () => {
  return useQuery(["realestates"], api.fetchRealEstates);
};

//--- get realestate ---//
export const GetRealEstate = (realEstateId) => {
  const queryClient = useQueryClient();
  return useQuery(["realestate", realEstateId], api.fetchRealEstate, {
    initialData: () => {
      const realestate = queryClient
        .getQueryData("realestate")
        ?.data.find((realestate) => realestate.id === parseInt(realEstateId));
      if (realestate) {
        return {
          data: realestate,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create realestate ---//
export const CreateRealEstate = () => {
  return useMutation(api.postRealEstate);
};

//--- update realestate ---//
export const UpdateRealEstate = () => {
  return useMutation(api.putRealEstate);
};

//--- delete realestate ---//

//////////////////////////////////////////////////////
//-------------------- BUILDING --------------------//
//////////////////////////////////////////////////////

//--- get buildings ---//
export const GetBuildings = () => {
  return useQuery(["buildings"], api.fetchBuildings);
};

//--- get building ---//
export const GetBuilding = (buildingId) => {
  const queryClient = useQueryClient();
  return useQuery(["building", buildingId], api.fetchBuilding, {
    initialData: () => {
      const building = queryClient
        .getQueryData("building")
        ?.data.find((building) => building.id === parseInt(buildingId));
      if (building) {
        return {
          data: building,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create building ---//
export const CreateBuilding = () => {
  return useMutation(api.postBuilding);
};

//--- update building ---//
export const UpdateBuilding = () => {
  return useMutation(api.putBuilding);
};

//--- delete building ---//

/////////////////////////////////////////////////////
//-------------------- ADDRESS --------------------//
/////////////////////////////////////////////////////

//--- get addresses ---//
export const GetAddresses = () => {
  return useQuery(["addresses"], api.fetchAddresses);
};

//--- create address ---//
export const CreateAddress = () => {
  return useMutation(api.postAddress);
};

//--- update address ---//
export const UpdateAddress = () => {
  return useMutation(api.putAddress);
};

//--- delete address ---//

////////////////////////////////////////////////////
//-------------------- OBJECT --------------------//
////////////////////////////////////////////////////

//--- get objects ---//
export const GetObjects = () => {
  return useQuery(["objects"], api.fetchObjects);
};
//--- get object ---//
export const GetObject = (objectId) => {
  const queryClient = useQueryClient();
  return useQuery(["object", objectId], api.fetchObject, {
    initialData: () => {
      const object = queryClient
        .getQueryData("object")
        ?.data.find((object) => object.id === parseInt(objectId));
      if (object) {
        return {
          data: object,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create object ---//
export const CreateObject = () => {
  return useMutation(api.postObject);
};

//--- update object ---//
export const UpdateObject = () => {
  return useMutation(api.putObject);
};

//--- delete object ---//

/////////////////////////////////////////////////////
//-------------------- SUBJECT --------------------//
/////////////////////////////////////////////////////

//--- get subjects ---//
export const GetSubjects = () => {
  return useQuery(["subjects"], api.fetchSubjects);
};
//--- get subject ---//
export const GetSubject = (subjectId) => {
  const queryClient = useQueryClient();
  return useQuery(["subject", subjectId], api.fetchSubject, {
    initialData: () => {
      const subject = queryClient
        .getQueryData("subject")
        ?.data.find((subject) => subject.id === parseInt(subjectId));
      if (subject) {
        return {
          data: subject,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create subject ---//
export const CreateSubject = () => {
  return useMutation(api.postSubject);
};

//--- update subject ---//
export const UpdateSubject = () => {
  return useMutation(api.putSubject);
};

//--- delete subject ---//

/////////////////////////////////////////////////////////////
//-------------------- ACCOUNTING PLAN --------------------//
/////////////////////////////////////////////////////////////

//--- get accountinplans ---//
export const GetAccountingPlans = () => {
  return useQuery(["accountingplans"], api.fetchAccountingPlans);
};

//--- get accountingplan ---//
export const GetAccountingPlan = (accountingPlanId) => {
  const queryClient = useQueryClient();
  return useQuery(
    ["accountingPlan", accountingPlanId],
    api.fetchAccountingPlan,
    {
      initialData: () => {
        const accountingPlan = queryClient
          .getQueryData("accountingPlan")
          ?.data.find(
            (accountingPlan) => accountingPlan.id === parseInt(accountingPlanId)
          );
        if (accountingPlan) {
          return {
            data: accountingPlan,
          };
        } else {
          return undefined;
        }
      },
    }
  );
};

//--- create accountingplan ---//
export const CreateAccountingPlan = () => {
  return useMutation(api.postAccountingPlan);
};

//--- update accountingplan ---//
export const UpdateAccountingPlan = () => {
  return useMutation(api.putAccountingPlan);
};

//--- delete accountingplan ---//
